import { Dialog, DialogContent } from "../../utils/components/ui/dialog";

import { cn } from "../../utils/cn";

type ModalProps = {
  children?: React.ReactNode;
  open: boolean;
  setOpen?: (open: boolean) => void;
  className?: string;
};

function Modal({ children, open, setOpen, className }: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={cn("max-w-[90vw] sm:max-w-[900px] w-full", className)}>
        {children && <div>{children}</div>}
      </DialogContent>
    </Dialog>
  );
}

export default Modal;
